export default __webpack_public_path__ + "static/media/barbara-rissi-hansbauer.1d81f3f6.jpg";